import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <Link onClick={() => window.open('https://cartao.tecmash.com.br')} to="#0">Contato</Link>
        </li>
        <li>
          <Link onClick={() => window.open('https://nextgoagenda.com/w/clczmw83p00zmb9015mubgdg0')} to="#0">Agenda</Link>
        </li>
        {/* <li>
          <Link to="#0">FAQ's</Link>
        </li> */}
        {/* <li>
          <Link to="mailto:contato@tecmash.com.br">Support</Link>
        </li> */}
      </ul>
    </nav>
  );
}

export default FooterNav;